import React from 'react';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Menu, MenuItem, Badge } from '@mui/material';
import { NotificationsActiveOutlined } from '@mui/icons-material';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';
import { useTranslation } from "react-i18next";

const NotificationsMenu = ({ anchorEl, open, handleClose, notificaciones, closeMenus }) => {
  const [t] = useTranslation("global");
  
  const unreadNotifications = notificaciones.filter(
    notificacion => notificacion.atendido == null
  );

  return (
    <Menu
      id="notifications-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "notificationsDropdown",
      }}
      PaperProps={{
        sx: {
          width: 320,
          maxHeight: 440,
          padding: 0
        },
      }}
    >
      <div className="mb-0 px-3 d-flex justify-content-between"
        style={{ paddingTop: "7px", paddingBottom: "15px" }}
      >
        <p style={{ fontSize: "19px" }} className="fw-medium mb-0">
          {t("navbar.notifications")}
        </p>
        <Link to="/Notificaciones" onClick={closeMenus} className="text-decoration-none">
          <small>Ver todas</small>
        </Link>
      </div>

      {unreadNotifications.length ? (
        unreadNotifications
          .sort((a, b) => new Date(b.createon) - new Date(a.createon))
          .slice(0, 3).map((notificacion) => (
            <MenuItem
              key={notificacion.id}
              component={Link}
              to="/Notificaciones"
              sx={{ display: "flex", alignItems: "start", padding: "12px" }}
              className="border-top border-light-subtle"
              onClick={closeMenus}
            >
              <div style={{ marginRight: "15px" }}>
                <Badge color="primary" variant="dot" />
              </div>
              <div className="d-flex flex-column" style={{ flex: 1 }}>
                <p className="m-0 fw-semibold">
                  {notificacion.titulo.length > 30 ? `${notificacion.titulo.substring(0, 30)}...` : notificacion.titulo}
                </p>
                <small>
                  {notificacion.descripcion.length > 37 ? `${notificacion.descripcion.substring(0, 37)}...` : notificacion.descripcion}
                </small>
                <small className="text-black-50 text-end">
                  {formatDistanceToNow(new Date(notificacion.createon), { addSuffix: true, locale: es })}
                </small>
              </div>
            </MenuItem>
          ))
      ) : (
        <div className="mb-0" style={{ height: "200px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <div style={{
            width: "60px",
            height: "60px",
            borderRadius: "15px",
            background: "#ebebeb",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "15px"
          }}
          >
            <NotificationsActiveOutlined style={{ color: "#c5c5c5", fontSize: "30px" }} />
          </div>
          <p className="m-0">Aún no tienes notificaciones pendientes</p>
          <small className="text-body-tertiary">Revisa más tarde.</small>
        </div>
      )}
    </Menu>
  );
};

export default NotificationsMenu;